export default {"src":"/_next/static/media/logoSitterWhiteDark.8112a5e1.svg","height":69,"width":134,"blurWidth":0,"blurHeight":0};